module.exports = __webpack_public_path__ + "static/media/expresswash.e4e9f04e.jpg";